/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import * as inscripcionActions from '../../actions/inscripcionActions';
import * as contableregistrogastoActions  from '../../actions/contableregistrogastoActions';
import InscripcionIndicadores from './InscripcionIndicadores';
import * as paginaActions from '../../actions/paginaActions';
import * as usuarioActions from '../../actions/usuarioActions';
import * as userActions from '../../actions/userActions';
import { Segment} from 'semantic-ui-react';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
import income from '../../data/income.json';
import $ from 'jquery';


class ManageIndicadores extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            ventaInvMf:[["monto","Periodo","Population","Estatus"],[300,"febrero/21",351014,"pagado"],[1314,"febrero/21",645526,"pendiente"],[815,"marzo/21",351014,"pagado"],[1314,"marzo/21",645526,"pendiente"]],
            permisos:{},
            reporte:{
                inscripcion:[]
            },
            total:0,
            totalVencido:0,
            totalPagado:0,
            totalGastos:0,
            totalPagos:0,
            totalPendiente:0,
            montoSinRegistroDePago:0,
            sinRegistrosDePago:0,
            grafica:[],
            graficaGastos:[],
            datoGrafica:[],
            datoGraficaGastos:[],
            egresosIngresos:[],
            egresosIngresos1:[],
            f:{fecha:""},
            fechas:[],
            axis:[]
 		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.idCurso;
        //console.log(id);
        /*
        let pageInfo={ 
            page:'inscripcion', 
            idioma:this.props.idioma     
        }; 
        */
        
        usuarioActual(this, "inscripcion",true).then( (usuario)=>{
        
         

            if(id && id>0 ){

                this.props.contableregistrogastoActions.getContableRegistroGastoReporte(id, this.props.user).then( reporte=>{

                    this.reporteGastos(reporte);

                }).catch(error=>{
                  toastr.error(error);
                });

                this.props.inscripcionActions.getReportePagos(id, this.props.user).then( reporte=>{

                   this.reportePagos(reporte);

                })
                .catch(error=>{
                  toastr.error(error);
                });


            }
            
        }).catch(error=>{
          toastr.error(error);
        }); 
    	
    }
    
    
    reportePagos=(reporte)=>{
        
          let total=0;
                let totalPagado=0;
                let totalPagos=0;
                let totalPendiente=0;
                let sinRegistrosDePago = 0;
                let montoSinRegistroDePago =0;
                let fecha="";
                let test=[];
                let acumulado=[];
                let testPagado=[];
                let testPagado2=[];
                let periodos=this.state.periodos;
                this.setState({"reporte":reporte});
                let graficaGastos =  this.state.egresosIngresos;
                let datoGraficaGastos = this.state.datoGraficaGastos;
                let fechas = Object.assign([], this.state.fechas);
                
                let grafica = Object.assign([], this.state.grafica);
                //let datoGrafica= = Object.assign([], this.state.grafica);
                let datoGrafica= ["monto","Periodo","Population","Estatus"];
                grafica.push(datoGrafica);
                datoGrafica=Object.assign([], this.state.datoGrafica);
                
                
                for(let i=0;i<reporte.inscripcion.length;i++){
                    total=total+reporte.inscripcion[i].costoTotal;
                    totalPagado=totalPagado+reporte.inscripcion[i].costoPagado;
                    if(reporte.inscripcion[i].noCuotas==null){
                        montoSinRegistroDePago = montoSinRegistroDePago + reporte.inscripcion[i].costoTotal;
                        sinRegistrosDePago = sinRegistrosDePago+1;
                    }
                    
                }
                
                for(let i=0;i<reporte.pagos.length;i++){
                    
                    let f = Object.assign({}, this.state.f);
                    f.fecha=reporte.pagos[i].fechaPago2;
                    fechas.push(f);
                    
                    fecha = reporte.pagos[i].fechaPago2.split('/');
                    if(reporte.pagos[i].pagado==1){
                        totalPagos=totalPagos+reporte.pagos[i].montoPago;
                        /// DATOS PARA GRAFICAR LO PAGADO                        
                        if(fecha.length>0){
                            if(testPagado[fecha[1]+"/"+fecha[0]]){
                                testPagado[fecha[1]+"/"+fecha[0]] = testPagado[fecha[1]+"/"+fecha[0]] + reporte.pagos[i].montoPago;

                            }else{
                                testPagado[fecha[1]+"/"+fecha[0]] = reporte.pagos[i].montoPago;

                            }    

                        }
                        
                    }else{
                         totalPendiente=totalPendiente+reporte.pagos[i].montoPago;
                    }
                        
                    if(fecha.length>0){

                        if(test[fecha[1]+"/"+fecha[0]]){
                            test[fecha[1]+"/"+fecha[0]] = test[fecha[1]+"/"+fecha[0]] + reporte.pagos[i].montoPago;

                        }else{
                            test[fecha[1]+"/"+fecha[0]] = reporte.pagos[i].montoPago;

                        }    

                    }

                   
                }
                
               fechas = fechas.sort(function (a, b) {
                      if (a.fecha > b.fecha) {
                        return 1;
                      }
                      if (a.fecha < b.fecha) {
                        return -1;
                      }
                      // a must be equal to b
                      return 0;
                    });
                
                
               
                let axis=[];
                for(let i=0;i<fechas.length;i++){
                    let f = fechas[i].fecha.split('/');
                    axis[f[1]+"/"+f[0]] = f[1]+"/"+f[0];
                }
                
                
                 let axisPrueba=[];
                 for (const [key, value] of Object.entries(axis)) {
                        //console.log(value);
                        axisPrueba.push(value);
                        
                }
                //console.log(axisPrueba);
                this.setState({axis:axisPrueba});
               
                
                
               let prueba =Object.assign([], testPagado);
               let lastValue = 0;
               let suma= 0;    
                for (const [key, value] of Object.entries(prueba)) {
                        suma = value+lastValue;
                        datoGraficaGastos=Object.assign([], this.state.datoGraficaGastos);
                        datoGraficaGastos.push(suma);
                        datoGraficaGastos.push(key);
                        datoGraficaGastos.push(1);
                        datoGraficaGastos.push('Ingresó');
                        graficaGastos.push(datoGraficaGastos);
                        lastValue = suma;
                    
                }
                this.setState({"egresosIngresos1":graficaGastos});
              
                for (const [key, value] of Object.entries(testPagado)) {
                    //console.log(key, value);
                    datoGrafica=Object.assign([], this.state.datoGrafica);
                    datoGrafica.push(value);
                    datoGrafica.push(key);
                    datoGrafica.push(1);
                    datoGrafica.push('Ingresado');
                    grafica.push(datoGrafica);
                }
                
                for (const [key, value] of Object.entries(test)) {
                    //console.log(key, value);
                    datoGrafica=Object.assign([], this.state.datoGrafica);
                    datoGrafica.push(value);
                    datoGrafica.push(key);
                    datoGrafica.push(1);
                    datoGrafica.push('Esperado');
                    grafica.push(datoGrafica);
                }
                
                
                this.setState({ventaInvMf:grafica});
                
                this.setState({"total":total});
                this.setState({"totalPagado":totalPagado});
                this.setState({"totalPagos":totalPagos});
                this.setState({"totalPendiente":totalPendiente});
                this.setState({"sinRegistrosDePago":sinRegistrosDePago});
                this.setState({"montoSinRegistroDePago":montoSinRegistroDePago});
               
        
        
    }
    
    reporteGastos=(reporte)=>{
        
         let datoGraficaGastos= ["monto","Periodo","Population","Estatus"];
                let graficaGastos = Object.assign([], this.state.graficaGastos);
                let totalGastos = 0;
                let test=[];
                let fecha="";
                let fechaAnt="";
                let periodos=[];
                let fechas = Object.assign([], this.state.fechas);
                
                for(let i=0;i<reporte.length;i++){
                    fecha = reporte[i].periodo.split('-');
                    let f = Object.assign({}, this.state.f);
                    f.fecha=fecha[0]+"/"+fecha[1]+"/01";
                    fechas.push(f);
                    if(fecha.length>0 && i==0){
                        //console.log(" primer IF :"+test[fecha[1]+"/"+fecha[0]]);
                        test[fecha[1]+"/"+fecha[0]] = reporte[i].monto;
                    }else{
                        if(fecha[0] == fechaAnt[0] && fecha[1] == fechaAnt[1]){
                            //console.log("IF :"+test[fecha[1]+"/"+fecha[0]]);
                            test[fecha[1]+"/"+fecha[0]] = reporte[i].monto  + test[fecha[1]+"/"+fecha[0]];
                        }else{
                            //console.log("ELSE :"+ test[fechaAnt[1]+"/"+fechaAnt[0]]);
                            test[fecha[1]+"/"+fecha[0]] = reporte[i].monto  + test[fechaAnt[1]+"/"+fechaAnt[0]]; 
                        }    
                        
                    }    
                    totalGastos = totalGastos + reporte[i].monto;
                    fechaAnt = reporte[i].periodo.split('-');
                }
                

                
                this.setState({fechas:fechas});
                
                graficaGastos.push(datoGraficaGastos);
                for (const [key, value] of Object.entries(test)) {
                        datoGraficaGastos=Object.assign([], this.state.datoGraficaGastos);
                        datoGraficaGastos.push(value);
                        datoGraficaGastos.push(key);
                        datoGraficaGastos.push(1);
                        datoGraficaGastos.push('Gasto');
                        graficaGastos.push(datoGraficaGastos);
                    }
               
                this.setState({"totalGastos":totalGastos});
                this.setState({"egresosIngresos":graficaGastos});
        
        
    }
  
    componentWillReceiveProps(nextProps) {	
     
        if(this.props.idCurso!=nextProps.idCurso){
        
          this.props.contableregistrogastoActions.getContableRegistroGastoReporte(nextProps.idCurso, this.props.user).then( reporte=>{
               
                this.reporteGastos(reporte);
                
            }).catch(error=>{
              toastr.error(error);
            });
            
            this.props.inscripcionActions.getReportePagos(nextProps.idCurso, this.props.user).then( reporte=>{
               
               this.reportePagos(reporte);
                
            })
            .catch(error=>{
              toastr.error(error);
            });
           
        }    
        
	}
   
       
    render() {	
        return (
                <InscripcionIndicadores 
                    idCurso={this.props.idCurso}
                    ventaInvMf={this.state.ventaInvMf}
                    strings={this.props.strings}
                    reporte={this.state.reporte}
                    total={this.state.total}
                    totalPagado={this.state.totalPagado}
                    totalPagos={this.state.totalPagos}
                    totalPendiente={this.state.totalPendiente}  
                    sinRegistrosDePago={this.state.sinRegistrosDePago}  
                    montoSinRegistroDePago={this.state.montoSinRegistroDePago} 
                    egresosIngresos={this.state.egresosIngresos1}
                    totalGastos={this.state.totalGastos}
                    axisvalores={this.state.axis}
                />
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings, 
        form:state.form,
        cursoCombo:state.cursoCombo,
        usuarioCombo:state.usuarioCombo,
        tipomonedaCombo:state.tipomonedaCombo,
        cursotipomonedaCombo:state.cursotipomonedaCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
            paginaActions: bindActionCreators(paginaActions, dispatch),
            usuarioActions: bindActionCreators(usuarioActions, dispatch),
            userActions: bindActionCreators(userActions, dispatch),
            inscripcionActions: bindActionCreators(inscripcionActions, dispatch),
            contableregistrogastoActions: bindActionCreators(contableregistrogastoActions, dispatch),
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageIndicadores);